import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)



const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: resolve => require(['@/view/login'], resolve),
      meta: {
        title: '智中诚'
      }
    },
    // {
    //   path: '/',
    //   name: 'PageView',
    //   component: resolve => require(['@/view/index'], resolve),
    //   children: [
    //     {
    //       path: '/',
    //       redirect: '/login'
    //     },{
    //       path: '/login',
    //       name: 'login',
    //       component: resolve => require(['@/view/login'], resolve),
    //       meta: {
    //         title: '智中诚'
    //       }
    //     }
        
    //   ]
    // },
    {
      path: '/periodization',
      name: 'periodization',
      component: resolve => require(['@/view/periodization/index'], resolve),
      meta: {
        title: '培训分期'
      }
    },{
      path: '/deductionAccount',
      name: 'deductionAccount',
      component: resolve => require(['@/view/periodization/deductionAccount'], resolve),
      meta: {
        title: '扣款账户'
      }
    },{
      path: '/trainingPayment',
      name: 'trainingPayment',
      component: resolve => require(['@/view/periodization/trainingPayment'], resolve),
      meta: {
        title: '培训付款'
      }
    },{
      path: '/protocol',
      name: 'protocol',
      component: resolve => require(['@/view/periodization/protocol'], resolve),
      meta: {
        title: ''
      }
    },{
      path: '/bill',
      name: 'bill',
      component: resolve => require(['@/view/bill/index'], resolve),
      meta: {
        title: '总计账单'
      }
    },{
      path: '/allDh',
      name: 'allDh',
      component: resolve => require(['@/view/bill/allDh'], resolve),
      meta: {
        title: '全部待还'
      }
    },{
      path: '/dhBill',
      name: 'dhBill',
      component: resolve => require(['@/view/bill/dhBill'], resolve),
      meta: {
        title: '全部待还'
      }
    },{
      path: '/billRecords',
      name: 'billRecords',
      component: resolve => require(['@/view/bill/billRecords'], resolve),
      meta: {
        title: '账单记录'
      }
    },{
      path: '/billDetail',
      name: 'billDetail',
      component: resolve => require(['@/view/bill/billDetail'], resolve),
      meta: {
        title: '账单详情'
      }
    },{
      path: '/yhBill',
      name: 'yhBill',
      component: resolve => require(['@/view/bill/yhBill'], resolve),
      meta: {
        title: '已还账单'
      }
    },{
      path: '/deduction',
      name: 'deduction',
      component: resolve => require(['@/view/bill/deduction'], resolve),
      meta: {
        title: '扣款管理'
      }
    },{
      path: '/more',
      name: 'more',
      component: resolve => require(['@/view/bill/more'], resolve),
      meta: {
        title: '更多'
      }
    },{
      path: '/yzmPage',
      name: 'yzmPage',
      component: resolve => require(['@/view/periodization/yzmPage'], resolve),
      meta: {
        title: '扣款账户'
      }
    },{
      path: '/uploadFile',
      name: 'uploadFile',
      component: resolve => require(['@/view/uploadFile'], resolve),
      meta: {
        title: '上传合同'
      }
    }
  ]
})


export default router
// new VueRouter
// const router = new VueRouter(RouterConfig)
